import { render } from "./BlankLayout.vue?vue&type=template&id=cf17459c"
const script = {}

import exportComponent from "/var/www/html/production/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__